import React, { Fragment, useState, useEffect } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';
import { Provider } from "react-redux";
import ReactDOM from "react-dom";


import { authRoutes, routes, iframeRoutes } from "./route";
import PrivateRoute from "./route/PrivateRoute";
import ToastWrapper from "./route/ToastWrapper";

import App      from "./app";
import security from "./services/security";
import store from "./redux/store";

import "./_config/axios";
import '~/assets/scss/app.scss';


const Root = ({})=> {

  const defaultBackground = "#e5e5e5";
  const breakpoint        = 991;

  const [background     , setBackground]     = useState(defaultBackground);
  const [expandedHeader , setExpandedHeader] = useState(false);

  const redirectIfUser = (routeProps, Component)=> {

    return  (security.currentUserValue)
      ? (<Redirect to={ {pathname: "/dashboard" } } />)
      : (<ToastWrapper msg={routeProps.location.message}> <Component {...routeProps}/> </ToastWrapper>);
  }

  return (
    <Fragment>


      <CookiesProvider>
        <Provider store={store}>
          <BrowserRouter basename={`/`}>
            <Switch>

              {iframeRoutes.map(({path, Component}) => (
                <PrivateRoute exact
                  path={`${process.env.PUBLIC_URL}${path}`}
                  setBackground={setBackground}
                  background={background || defaultBackground}
                  breakpoint={breakpoint}
                  expandedHeader={expandedHeader || false}
                  setExpandedHeader={setExpandedHeader}
                  render={(routeProps)=> (<ToastWrapper msg={routeProps.location.message}> <Component {...routeProps}/> </ToastWrapper>) }
                  key={path} />
              )
              )}

              <App breakpoint={breakpoint} background={background} expandedHeader={expandedHeader} setExpandedHeader={setExpandedHeader}>
                <Switch>

                  {authRoutes.map(({ path, Component }) => (
                    <Route
                      exact
                      key={path}
                      path={`${process.env.PUBLIC_URL}${path}`}
                      render={ (routeProps)=> redirectIfUser(routeProps, Component) }
                      />
                  ))}

                  {routes.map(({ path, Component, background, expandedHeader })=> (
                    <PrivateRoute
                      exact
                      key={path}
                      setBackground={setBackground}
                      breakpoint={breakpoint}
                      background={background || defaultBackground}
                      expandedHeader={expandedHeader || false}
                      setExpandedHeader={setExpandedHeader}
                      path={`${process.env.PUBLIC_URL}${path}`}
                      render={(routeProps)=> (<ToastWrapper msg={routeProps.location.message}> <Component {...routeProps } /> </ToastWrapper>) }
                      />
                  ))}

                  <Redirect to="/dashboard" />
                </Switch>
              </App>
            </Switch>
          </BrowserRouter>
        </Provider>
      </CookiesProvider>
    </Fragment>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));
